import Service from "../../Services";

const Members = {
  namespaced : true,
  state : {
    form : {
      branch_id : '',
      title_th : '',
      title_en : '',
      detail_en : '',
      detail_th : '',
      slug_url : '',
      member_topic_type_id : '',
      is_publish : true,
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        branch_id : '',
        title_th : '',
        title_en : '',
        detail_en : '',
        detail_th : '',
        slug_url : '',
        member_topic_type_id : '',
        is_publish : true,
      }
    }
  },
  actions : {
    getMemberTopicData({commit}){
      return Service.MembersAPI.getMemberTopicType();
    },
    getMembers({commit},{page,search,sort_date}){
      return Service.MembersAPI.getMembers(page,search,sort_date);
    },
    showMembers({commit},id){
      return Service.MembersAPI.showMembers(id);
    },
    saveMembers({commit},{id,data}){
      if(id){
        return Service.MembersAPI.updateMembers(id,data);
      }else{
        return Service.MembersAPI.createMembers(data);
      }
    },
    deleteMembers({commit},id){
      return Service.MembersAPI.deleteMembers(id);
    },
    setFormMembers({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default Members
